import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import accountReducer from './containers/accountSlice';
import plansReducer from './containers/plans/planSlice';
import ordersReducer from './containers/orders/orderSlice';
import salesReducer from './containers/sales/salesSlice';
import {api} from './services/api';
import authMiddleware from './auth.middleware';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
	reducer: {
		[api.reducerPath]: api.reducer,
		account: accountReducer,
		plans: plansReducer,
		orders: ordersReducer,
		sales: salesReducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware()
		.concat(sagaMiddleware)
		.concat(api.middleware)
		.concat(authMiddleware)
});

// sagaMiddleware.run(mySaga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
